import { IGroupSpaceResource } from "../../group-spaces";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";

export type IGroupSpaceSortTasksMutationParameters = {
    groupSpace?: RelationalValue<IGroupSpaceResource>;
    personalGroupTasksToSort: string[];
};

export type IGroupSpaceSortTasksMutationResult = IGroupSpaceResource;

export const groupSpaceSortTasksMutation: IApiMutationFunction<IGroupSpaceSortTasksMutationParameters> = ({
    groupSpace,
    personalGroupTasksToSort,
}) => ({
    method: "PATCH",
    url: `/group_spaces/${mapRelationalValue(groupSpace)}/sort_group_tasks`,
    data: {
        personalGroupTasksToSort,
    },
    headers: {
        "Content-Type": "application/merge-patch+json",
    },
});

export const useGroupSpaceSortTasksMutation = createApiMutationHook<
    IGroupSpaceSortTasksMutationParameters,
    IGroupSpaceSortTasksMutationResult
>(groupSpaceSortTasksMutation);
